export default "/build/images/map-marker.a201dac2.png";